import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'
import { s_blog } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import BlogCard from '../BlogCard'
import { IBlogPostListSection } from '../type'

const BlogTagPostListSection = ({ posts = [], fetchFunction, cacheKey, isMobile }: IBlogPostListSection) => {
  const { query } = useRouter()
  const { t } = useTranslation()
  const [listArray, setListArray] = useState([...posts])
  const [loadMore, setLoadMore] = useState(true)
  const ENG_BLOG_INDEX = isMobile ? 6 : 8 //불러오는 블로그 인덱스
  const CALL_BLOG_NUMBER = isMobile ? 7 : 9 //불러오는 블로그 갯수
  const [start, setStart] = useState(0)
  const [end, setEnd] = useState(ENG_BLOG_INDEX)

  const {
    data: morePosts,
    isLoading,
    status,
  } = useQuery({
    queryKey: cacheKey(query.tag, start, end),
    queryFn: () => fetchFunction(start, end),
  })

  useEffect(() => {
    setListArray(posts)
    setLoadMore(true)
    setStart(0)
    setEnd(ENG_BLOG_INDEX)
  }, [posts])

  useEffect(() => {
    if (status === 'success' && morePosts && end > CALL_BLOG_NUMBER) {
      if (morePosts.length > 0) {
        if (morePosts.length < CALL_BLOG_NUMBER) {
          setLoadMore(false)
        }
        setListArray((prevPosts) => [...prevPosts, ...morePosts])
      } else if (morePosts.length === 0) {
        setLoadMore(false)
      }
    }
  }, [status, morePosts, end])

  // useCallback을 사용하여 이 함수를 메모이제이션
  const handleButtonClick = useCallback(() => {
    setStart((prevStart) => prevStart + CALL_BLOG_NUMBER)
    setEnd((prevEnd) => prevEnd + CALL_BLOG_NUMBER)
  }, [])

  return (
    <div className={style(isMobile).contentsListBodySectionLayout}>
      <div className={style(isMobile).contentsListBodySectionWrapper}>
        {listArray?.map((postItem, i) => {
          return (
            <div key={i}>
              <BlogCard
                isMobile={isMobile}
                title={postItem.title}
                subtitle={postItem.subtitle}
                thumbnail={postItem.thumbnail}
                slug={postItem.slug?.current}
                tagLists={postItem.tagLists}
                category={postItem.category}
                subCategory={postItem.subCategory}
              />
            </div>
          )
        })}
      </div>

      {loadMore && (
        <div className={style(isMobile).seeMoreButtonLayout}>
          <DSButton size={BUTTON_SIZE.MD} onClick={handleButtonClick} type={BUTTON_TYPE.OUTLINE} isLoading={isLoading}>
            <DSButton.Label className="Body2-14Bd">{t(s_blog.category.see_more)}</DSButton.Label>
          </DSButton>
        </div>
      )}
    </div>
  )
}
export default BlogTagPostListSection

const style = (isMobile) =>
  isMobile
    ? {
        contentsListBodySectionLayout: `flex w-full flex-col justify-center px-[16px]`,
        contentsListBodySectionWrapper: `mx-auto flex flex-col justify-center gap-y-[12px]`,
        seeMoreButtonLayout: `mx-auto mt-[48px] w-full`,
      }
    : {
        contentsListBodySectionLayout: ``,
        contentsListBodySectionWrapper: `grid grid-cols-3 gap-x-[16px] gap-y-[60px]`,
        seeMoreButtonLayout: `mx-auto mt-[48px] w-[160px]`,
      }
